import React from 'react'
import PropTypes from 'prop-types';
import './style.scss';

const WCBackground = ({ children, noPaddingBottom }) => (
  <div className={`wc-background${noPaddingBottom ? ' wc-background--no-padding-bottom' : ''}`}>
    <div className="wc-background__glow" aria-hidden="true" />
    {children}
  </div>
);

WCBackground.propTypes = {
  children: PropTypes.node.isRequired,
  noPaddingBottom: PropTypes.bool,
};

export default WCBackground;
